export const baseUrl = 'http://localhost:3000/api/';


//  export const greenhseBaseUrl = 'http://localhost/test/'
export const greenhseBaseUrl = `https://www.getestimate.greenhse.com/api/`

export const emailAndAddress = 'www.greenhse.com . sales@greenhse.com'